import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectUserName, setSignOutState, setUserLoginDetails, selectUserPhoto } from '../features/user/userSlice';
import { auth, provider } from '../firebase';

const Header = () => {
    const dispatch=useDispatch();
    const history=useHistory();
    const username= useSelector(selectUserName);
    const userphoto= useSelector(selectUserPhoto);

    useEffect(()=>{
        auth.onAuthStateChanged(async (user)=>{
            if(user){
                setUser(user);
                history.push("/home");
            }
        })
    },[username])

    const handleAuth=()=>{
        if (!username) {
            auth
              .signInWithPopup(provider)
              .then((result) => {
                setUser(result.user);
              })
              .catch((error) => {
                alert(error.message);
              });
        } else if (username) {
        auth
            .signOut()
            .then(() => {
            dispatch(setSignOutState());
            history.push("/");
            })
            .catch((err) => alert(err.message));
        }
    };

    const setUser = (user) =>
    {
        dispatch(
            setUserLoginDetails({
                name: user.displayName,
                email: user.email,
                photo: user.photoURL,
            })
        )
    }

    return (
        <div>
            <Nav>
                <Logo>
                    <img src="/images/logo.svg" alt="Disney+"/>
                </Logo>
                {
                !username?
                <Login onClick={handleAuth}>Login</Login>:
                <>
                <NavMenu>
                <a href="/home">
                    <img src="/images/home-icon.svg" alt="HOME" />
                    <span>HOME</span>
                </a>
                <a href="/search">
                    <img src="/images/search-icon.svg" alt="SEARCH" />
                    <span>SEARCH</span>
                </a>
                <a href="/list">
                    <img src="/images/watchlist-icon.svg" alt="WATCHLIST" />
                    <span>WATCHLIST</span>
                </a>
                <a href="/orig">
                    <img src="/images/original-icon.svg" alt="ORIGINALS" />
                    <span>ORIGINALS</span>
                </a>
                <a href="/movies">
                    <img src="/images/movie-icon.svg" alt="MOVIES" />
                    <span>MOVIES</span>
                </a>
                <a href="/series">
                    <img src="/images/series-icon.svg" alt="SERIES" />
                    <span>SERIES</span>
                </a>
                </NavMenu>
                <SignOut>
                    <UserImg src={userphoto} alt={username} />
                    <DropDown>
                    <span onClick={handleAuth}>Sign out</span>
                    </DropDown>
                </SignOut>
                </>
                }
            </Nav>
        </div>
    )
}

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background-color: #090b13;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 36px;
  letter-spacing: 16px;
  z-index: 3;
`;

const Logo = styled.a`
  padding: 0;
  width: 80px;
  margin-top: 4px;
  max-height: 70px;
  font-size: 0;
  display: inline-block;
  img {
    display: block;
    width: 100%;
  }
`;

const NavMenu = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  height: 100%;
  justify-content: flex-end;
  margin: 0px;
  padding: 0px;
  position: relative;
  margin-right: auto;
  margin-left: 25px;
  
  a{
    display: flex;
    align-items: center;
    padding: 0 12px;
    img {
      height: 25px;
      min-width: 20px;
      padding: 0px 0px 2px 0px;
      width: 20px;
      z-index: auto;
    }
    span {
      font-size: 13px;
      letter-spacing: 1.5px;
      line-height: 1.08;
      padding: 2px 0px;
      white-space: nowrap;
      position: relative;
    
        &:hover {
        border-bottom: 2px solid white;
        }

        @media (max-width: 768px)
        {
            display: none;
        }
    }
   }
`;

const Login = styled.a`
   background-color: #090b13;
   padding: 8px 16px;
   text-transform: uppercase;
   letter-spacing: 1.5px;
   border: 1px solid #f9f9f9;
   border-radius: 4px;
   transition: all 0.2s ease 0s;

   &:hover{
       background-color: #f9f9f9;
       color:#000;
       cursor: pointer;
       border-color: transparent;
   }
`;

const UserImg = styled.img`
  height: 100%;
`;

const DropDown = styled.div`
  position: absolute;
  top: 48px;
  right: 0px;
  background: rgb(19, 19, 19);
  border: 1px solid rgba(151, 151, 151, 0.34);
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 50%) 0px 0px 18px 0px;
  padding: 10px;
  font-size: 14px;
  letter-spacing: 3px;
  width: 100px;
  opacity: 0;
`;

const SignOut = styled.div`
  position: relative;
  height: 48px;
  width: 48px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  ${UserImg} {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
  &:hover {
    ${DropDown} {
      opacity: 1;
      transition-duration: 1s;
    }
  }
`;

export default Header;
